export default __webpack_public_path__ + "static/media/25.6327273d.jpg";